import { render, staticRenderFns } from "./CombinedRule.vue?vue&type=template&id=309668d3&scoped=true"
import script from "./CombinedRule.vue?vue&type=script&lang=ts"
export * from "./CombinedRule.vue?vue&type=script&lang=ts"
import style0 from "./CombinedRule.vue?vue&type=style&index=0&id=309668d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309668d3",
  null
  
)

export default component.exports